import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Register ELVTR's custom typography utilities (defined in
// app/globals.css) under the `font-size` group so tailwind-merge does
// not strip a sibling color class — without this, e.g.
// `cn('text-primary-foreground', 'text-body')` resolves to just
// `text-body` because `text-body` is misclassified as a text-color
// utility.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['display', 'h1', 'h2', 'h3', 'body', 'caption'] },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
